(function () {
    console.log('Custom script loaded');

    /* Cart */
	let checker = document.getElementById('cart-tec');
	let checker2 = document.getElementById('cart-tec-2');

	if (checker && checker2) {
		checker.value = false;
		checker2.value = false;
		let sendbtn = document.getElementById('cart-tec-checkout');
		let must_accept = document.querySelector('.must-accept');
		// console.log('checker', checker);
		// console.log('sendbtn', sendbtn);
		checker.onchange = function() {
			// console.log('test', !this.checked);
			this.value = this.checked;
			if (this.checked && checker2.checked) {
				must_accept.classList.add('must-accept-hidden');
			}
			// sendbtn.disabled = !this.checked;
		};
		checker2.onchange = function() {
			// console.log('test', !this.checked);
			this.value = this.checked;
			if (this.checked && checker.checked) {
				must_accept.classList.add('must-accept-hidden');
			}
			// sendbtn.disabled = !this.checked;
		};

		if (sendbtn) {
			sendbtn.addEventListener("click", (event) => {
				// alert('checkbox');
				// console.log('checker.checked', checker.checked);
				if (!checker.checked || !checker2.checked) {
					// alert('checkbox');
					must_accept.classList.remove('must-accept-hidden');
					event.preventDefault();
					event.stopPropagation();
					return false;
				} else {
					console.log('GO TO CHECKOUT');
				}
			});
		}
	}
})();
